import { useRef } from "react"
import "./AccountMobileMenu.css"
import { Drawer, DrawerRef } from "../../../components/drawers/Drawer"
import { FontAwesomeIcons } from "../../../core/Types"
import { openModulePageDrawer } from "../../../core/Global"
import Icon from "../../../components/base/Icon"
import { MobileMenuItem } from "../../../components/mobile/MobileMenuItem"
import { ISideMenuItem } from "../../../components/layouts/aside/SideMenu"

interface IProps {
    title: string
    titleIcon?: FontAwesomeIcons
    items: ISideMenuItem[]
    onClose: () => void
}

// iOS-style palette so inner rows are colored like the Account page (not gray)
const PALETTE = ["#007aff", "#34c759", "#ff9500", "#af52de", "#5856d6", "#ff3b30", "#5ac8fa", "#ff2d55"]

// Group the flat side-menu items (already role-filtered) by their separators,
// which act as section headers — exactly like the desktop sidebar grouping.
function toGroups(items: ISideMenuItem[]) {
    const groups: { name?: string, items: ISideMenuItem[] }[] = []
    let current: { name?: string, items: ISideMenuItem[] } | null = null
    for (const it of items) {
        if (it.seperator) {
            current = { name: it.name, items: [] }
            groups.push(current)
        } else {
            if (!current) { current = { items: [] }; groups.push(current) }
            current.items.push(it)
        }
    }
    return groups.filter(g => g.items.length > 0)
}

export default function ModuleMenuDrawer(props: IProps) {

    const drawer = useRef<DrawerRef>(null)

    const groups = toGroups(props.items)
    let colorIndex = 0

    return (
        <Drawer ref={drawer} title={props.title} titleIcon={props.titleIcon}
            noPadding groupedBg onClose={props.onClose}>
            <div className="tg-account tg-account-drawer">
                {groups.map((group, gi) =>
                    <div key={gi}>
                        {group.name && <div className="tg-group-title">{group.name}</div>}
                        <div className="tg-group">
                            {group.items.map(it => {
                                const color = PALETTE[colorIndex++ % PALETTE.length]
                                return (
                                    <MobileMenuItem key={it.id ?? it.link}
                                        onClick={() => openModulePageDrawer(it.name ?? "", it.link ?? "")}>
                                        <div className="tg-row">
                                            <div className="tg-row-icon" style={{ backgroundColor: color }}>
                                                {it.icon && <Icon icon={it.icon} type="solid" size={15} />}
                                            </div>
                                            <div className="tg-row-body">
                                                <span className="tg-row-label">{it.name}</span>
                                                <Icon icon="chevron-right" size={13} className="tg-row-chevron" />
                                            </div>
                                        </div>
                                    </MobileMenuItem>
                                )
                            })}
                        </div>
                    </div>
                )}
            </div>
        </Drawer>
    )
}
